import React, { useEffect, useState } from 'react'
import API from '../../../services/api'
import NoData from '../NoData'
import Loader from '../../Commons/Loaders/Loader'
import PartnerCardTable from './PartnerCardTable'
import { toast } from 'react-toastify'

const Partner = ({ search }) => {
    const [rows, setRows] = useState([])
    const [totalItems, setTotalItems] = useState(0)
    const [firstLoading, setFirstLoading] = useState(true)
    const [loading, setLoading] = useState(true)
    function fetchPartnersList() {
        setLoading(true)
        API.Partners.list(search).then((response) => {
            response.json().then((data) => {
                setRows(data['hydra:member'])
                setTotalItems(data['hydra:totalItems'])
                setLoading(false)
                setFirstLoading(false)
            })
        })
    }

    useEffect(() => {
        fetchPartnersList()
    }, [search])

    const handleDeletePartner = (id) => {
        API.Partners.delete(id)
            .then((response) => {
                toast.success('Partenaire supprimé.')
                fetchPartnersList()
            })
            .catch((error) => {
                toast.warn(
                    'Impossible de supprimer le partenaire car il a été utilisé,'
                )
            })
    }

    return (
        <div>
            {firstLoading ? (
                <Loader />
            ) : rows.length > 0 ? (
                <PartnerCardTable
                    rows={rows}
                    totalItems={totalItems}
                    handleDeleteElement={handleDeletePartner}
                    loading={loading}
                />
            ) : (
                <NoData message="Aucun partenaire disponible" />
            )}
        </div>
    )
}

export default Partner
